import { logEvent } from 'commons/utils/tracking';
import {
  ONBOARDING_RECOMMENDED_PLAN_FREE_CLICK,
  ONBOARDING_RECOMMENDED_PLAN_SCREEN_SHOW,
  ONBOARDING_RECOMMENDED_PLAN_TEST_CLICK,
  ONBOARDING_RECOMMENDED_SEE_OTHER_PLANS_CLICK,
} from 'config/trackingEvents';

export const trackingOnboardingRecommendedPlanScreenShow = (): void => {
  logEvent(ONBOARDING_RECOMMENDED_PLAN_SCREEN_SHOW, {});
};

export const trackingOnboardingRecommendedPlanFreeClick = (): void => {
  logEvent(ONBOARDING_RECOMMENDED_PLAN_FREE_CLICK, {});
};

export const trackingOnboardingRecommendedPlanTestClick = (): void => {
  logEvent(ONBOARDING_RECOMMENDED_PLAN_TEST_CLICK, {});
};

export const trackingOnboardingRecommendedSeeOtherPlansClick = (): void => {
  logEvent(ONBOARDING_RECOMMENDED_SEE_OTHER_PLANS_CLICK, {});
};
